import clsx from 'clsx';

interface IconProps {
  name: string;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  variant?: 'outlined' | 'rounded';
  filled?: boolean;
  weight?: 100 | 200 | 300 | 400 | 500 | 600 | 700;
  className?: string;
}

const sizeClasses = {
  small: 'text-lg',
  medium: 'text-2xl',
  large: 'text-4xl',
  xlarge: 'text-6xl',
};

/**
 * Google Material Symbols component (M3)
 * 
 * Usage: 
 *   <Icon name="gavel" />                    // Default outlined
 *   <Icon name="favorite" filled />          // Filled variant
 *   <Icon name="home" variant="rounded" />   // Rounded style
 *   <Icon name="star" weight={700} />        // Bold weight
 * 
 * Find icons at: https://fonts.google.com/icons
 */
export default function Icon({ 
  name, 
  size = 'medium', 
  variant = 'outlined',
  filled = false,
  weight = 400,
  className 
}: IconProps) {
  const fontVariationSettings = `'FILL' ${filled ? 1 : 0}, 'wght' ${weight}, 'GRAD' 0, 'opsz' 24`;
  
  return (
    <span
      className={clsx(
        variant === 'rounded' ? 'material-symbols-rounded' : 'material-symbols-outlined',
        sizeClasses[size],
        className
      )}
      style={{ fontVariationSettings }}
    >
      {name}
    </span>
  );
}
